import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, computed } from 'vue';
import { UploadType } from '@/gql/graphql';
import { BAlert, BButton, BModal, BSpinner } from 'bootstrap-vue-next';
import { useUploadsStore } from '@/store/uploads';


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadAbort',
  props: {
    show: { type: Boolean },
    upload: {}
  },
  emits: ['close', 'closeAndRefresh'],
  setup(__props: any, { emit: __emit }) {

const uploadsStore = useUploadsStore();

// --- Component properties ---
const props = __props;

// --- Component emits ---
const emits = __emit;

// --- Component state ---
const show = computed<boolean>(() => {
  return props.show;
});

// --- Abort Progress Indicators ---
const abortInProgress = ref<boolean>(false);
const abortError = ref<string | null>(null);
const abortShowSuccess = ref<boolean>(false);

// --- Handle component actions ---
async function onAbortConfirmed() {
  if (!props.upload.id) {
    abortError.value = 'Upload ID for abortion not provided';
    console.error('Upload ID for abortion not provided');
    return;
  }

  // stop upload immediately and update the status
  abortInProgress.value = true;
  try {
    // abort the upload handled by uploadsStore
    await uploadsStore.abortUpload(props.upload.id);
    // show success indicator
    abortShowSuccess.value = true;
    setTimeout(() => {
      abortShowSuccess.value = false;
      emits('closeAndRefresh');
    }, 1000);
  } catch (err: unknown) {
    if (err instanceof Error) {
      abortError.value = `Error updating upload status to aborted: ${err.message}`;
    } else {
      abortError.value = 'Error updating upload status to aborted';
    }
  } finally {
    abortInProgress.value = false;
  }
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "times",
          class: "me-2"
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" Abort upload ", -1))
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: handleCloseModal
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          variant: "danger",
          disabled: abortInProgress.value || abortShowSuccess.value,
          onClick: onAbortConfirmed
        }, {
          default: _withCtx(() => [
            (abortInProgress.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Requesting Abortion ", -1)),
                  _createVNode(_unref(BSpinner), {
                    small: "",
                    label: ""
                  })
                ]))
              : (abortShowSuccess.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _cache[8] || (_cache[8] = _createTextVNode(" Abortion Requested ", -1)),
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', 'check-double'],
                      class: "me-2"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, " Abort Upload "))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _cache[4] || (_cache[4] = _createTextVNode(" Are you sure you want to abort the upload of ", -1)),
            _createElementVNode("strong", null, _toDisplayString(props.upload.targetFileName), 1),
            _cache[5] || (_cache[5] = _createTextVNode("? ", -1))
          ]),
          _createVNode(_unref(BAlert), {
            modelValue: abortError.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((abortError).value = $event)),
            variant: "danger",
            dismissible: "",
            class: "mt-3",
            onDismissed: _cache[1] || (_cache[1] = ($event: any) => (abortError.value = null))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(abortError.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})